import { Gauge, Wrench, FileCheck, Settings } from 'lucide-react';

export const TYPE_META = {
  inspection: { label: 'Inspection', icon: FileCheck, cls: 'text-emerald-400 bg-emerald-500/10' },
  measurement: { label: 'Mesures freins/pneus', icon: Gauge, cls: 'text-amber-400 bg-amber-500/10' },
  work_order: { label: 'Bon de travail', icon: Wrench, cls: 'text-blue-400 bg-blue-500/10' },
  maintenance: { label: 'Entretien', icon: Settings, cls: 'text-sky-400 bg-sky-500/10' },
};

export const AuditTable = ({ records, onVersions }) => (
  <div className="overflow-x-auto rounded-xl border border-slate-700/60" data-testid="audit-table">
    <table className="w-full text-xs">
      <thead className="bg-slate-800/70 text-slate-400">
        <tr>
          <th className="text-left p-2">Date</th><th className="text-left p-2">Unité</th><th className="text-left p-2">Type</th>
          <th className="text-left p-2">Document</th><th className="text-left p-2">Détail</th><th className="text-left p-2">Par</th><th className="p-2">Version</th>
        </tr>
      </thead>
      <tbody>
        {records.map(r => {
          const m = TYPE_META[r.type] || TYPE_META.work_order;
          const Icon = m.icon;
          return (
            <tr key={`${r.type}-${r.id}`} className={`border-t border-slate-800 ${r.cancelled ? 'opacity-70' : ''}`} data-testid={`audit-row-${r.id}`}>
              <td className="p-2 text-slate-300 whitespace-nowrap">{r.date}</td>
              <td className="p-2 text-white font-medium">{r.vehicle_unit || '—'}</td>
              <td className="p-2"><span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full ${m.cls}`}><Icon size={11} />{m.label}</span></td>
              <td className={`p-2 ${r.cancelled ? 'text-red-400 font-semibold' : 'text-white'}`}>
                {r.title}
              </td>
              <td className="p-2 text-slate-400 max-w-xs truncate" title={r.detail}>{r.detail}</td>
              <td className="p-2 text-slate-400">{r.by}</td>
              <td className="p-2 text-center">
                {r.version > 1 ? (
                  <button onClick={() => onVersions(r)} className="px-2 py-0.5 rounded bg-violet-500/20 text-violet-300 print:bg-transparent" data-testid={`audit-versions-${r.id}`}>v{r.version}</button>
                ) : <span className="text-slate-500">v1</span>}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);
